import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * EntitySlugRedirect
 * -------------------
 * Handles /countries/:slug, /organizations/:slug and /people/:slug routes for
 * human visitors. These routes now redirect to the query-parameter driven SPA
 * (/ ?country=united-states, etc.) so filters can be unlocked like the compare
 * page. Bots are handled at the edge (vercel.json) and keep receiving static
 * HTML.
 */
export default function EntitySlugRedirect({ entityType }) {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    if (!slug) {
      navigate('/', { replace: true });
      return;
    }

    const queryKeyMap = {
      organization: 'organization',
      person: 'person',
      region: 'region',
      country: 'country'
    };
    const queryKey = queryKeyMap[entityType] || 'country';

    const search = new URLSearchParams();
    search.set(queryKey, slug);

    navigate({ pathname: '/', search: `?${search.toString()}` }, { replace: true });
  }, [entityType, slug, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Redirecting…
    </div>
  );
}
